module.exports = __webpack_public_path__ + "img/full-pack.b8e6ac8a.svg";